import React from "react";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";

// Components ///
import Button from "../../atoms/button/button";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Styles //
import "./bannerSmall.scss";

const BannerSmall = (props: ReferenciaContenido) => {
    const {
        tituloGeneral,
        tituloBoton,
        redireccionBoton,
        imagenPrincipal,
        descripcion,
        referenciaPlantillaContenido
    } = props;
    const url = new URL(window.location.href);

    return (
        <div
            className={`o-banner-small ${
                props.contentful_id === "6IkoAfhnMSP31Dsi2yGrdY"
                    ? "o-verificationMpc"
                    : ""
            }`}
        >
            <div className={`container-mpc`}>
                <div className="o-banner-small__content">
                    <img
                        src={imagenPrincipal.file.url}
                        alt="Imagen mpc"
                        className="o-banner-small__image"
                    />
                    <div className="o-banner-small__container-text">
                        <h2 className="o-banner-small__title">
                            {tituloGeneral}
                        </h2>
                        <p className="o-banner-small__paragraph">
                            {descripcion.json.content[0].content[0].value}
                        </p>
                        <p className="o-banner-small__paragraph2">
                            {descripcion.json.content[1].content[0].value}
                        </p>
                        <Button
                            type="link"
                            text={tituloBoton}
                            classname={
                                url.pathname === "/personas/"
                                    ? `a-button__green`
                                    : `a-button__magenta bannerSmallButton`
                            }
                            href={redireccionBoton}
                            isDisabled={false}
                        />
                    </div>
                    <div className="o-banner-small__cards">
                        {referenciaPlantillaContenido.map((item,index) => (
                            <div className="card-content" key={index}>
                                {item.descripcion && contentfulRenderOptions(item.descripcion.json)}
                                <h2>{item.tituloBanner}</h2>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BannerSmall;
